<template>
<v-container>
  <v-card>
    <v-card-title>
      <strong>Tracciati import</strong>

      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search">
      <template slot="items" slot-scope="props">
        
          <td class="text-xs-left">{{ props.item.codcli }}</td>
          <td class="text-xs-left">{{ props.item.cartella }}</td>
          <td class="text-xs-left">{{ props.item.attivo }}</td>
          <td class="text-xs-left">{{ props.item.ftpuser }}</td>

        
      </template>
      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >From {{ pageStart }} to {{ pageStop }}</template>
    </v-data-table>
  </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search: "",
      pagination: {},
      headers: [
        { text: "Codice cliente", align: "left", value: "codcli" },
        { text: "Cartella", align: "left", value: "cartella" },
        { text: "Attivo", align: "left", value: "attivo" },
        { text: "Utente ftp", align: "left", value: "ftpuser" },
      ],
      items: []
    };
  },
  mounted() {
    //this.CheckJWT();
    this.GetTipoIncasso();
  },
  methods: {
    GetTipoIncasso() {
      axios.get(this.$store.state.servicePath + "/api/ArImportTraccs").then(res => {
        this.items = res.data;
      });
    },
    
   CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    }
  }
};
</script>